import { useState } from 'react';
import { Form } from 'antd';
import {
	useCreateSafetyAndHygieneResponsible,
	useGetListSafetyAndHygieneResponsible
} from '@/hooks/v2/safety-hygiene-responsible';

const { useWatch } = Form;

interface UseHygieneServiceResponsibleProps {
	fieldName?: string | string[];
}

export function useHygieneServiceResponsible({ fieldName }: UseHygieneServiceResponsibleProps) {
	const field = Array.isArray(fieldName) ? fieldName[0] : null;
	const [name, setName] = useState<string>('');

	const { mutate: createSafetyAndHygieneResponsible } = useCreateSafetyAndHygieneResponsible();

	const organization_id = useWatch(field ? [field, 'organization_id'] : 'organization_id');
	const company_id = useWatch(field ? [field, 'company_id'] : 'company_id');

	const { isLoading, data: hygieneServiceResponsible } = useGetListSafetyAndHygieneResponsible({
		organization_id: organization_id!,
		company_id: company_id!
	});

	function handleInputChange(event: React.ChangeEvent<HTMLInputElement>): void {
		setName(event.target.value);
	}

	function addItem(e: React.MouseEvent<HTMLAnchorElement>): void {
		e.preventDefault();

		if (!name.trim()) {
			return;
		}

		createSafetyAndHygieneResponsible({
			name: name.trim(),
			company_id,
			organization_id
		});

		setName('');
	}

	function handleSearch(value: string): void {
		if (value.length > 2) {
		}
	}

	const data =
		hygieneServiceResponsible && hygieneServiceResponsible.rows
			? hygieneServiceResponsible.rows.map((item) => ({
					label: item.name,
					value: item.id
				}))
			: [];

	return { data, isLoading, addItem, handleSearch, handleInputChange };
}
